<template>
  <div data-menu class="flex h-full w-full items-center justify-center">
    <button @click.stop="$emit('toggle')">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <mask
          id="mask0_5658_1081"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="25"
          height="24"
        >
          <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5658_1081)">
          <path
            d="M12.5 20C11.95 20 11.4792 19.8042 11.0875 19.4125C10.6958 19.0208 10.5 18.55 10.5 18C10.5 17.45 10.6958 16.9792 11.0875 16.5875C11.4792 16.1958 11.95 16 12.5 16C13.05 16 13.5208 16.1958 13.9125 16.5875C14.3042 16.9792 14.5 17.45 14.5 18C14.5 18.55 14.3042 19.0208 13.9125 19.4125C13.5208 19.8042 13.05 20 12.5 20ZM12.5 14C11.95 14 11.4792 13.8042 11.0875 13.4125C10.6958 13.0208 10.5 12.55 10.5 12C10.5 11.45 10.6958 10.9792 11.0875 10.5875C11.4792 10.1958 11.95 10 12.5 10C13.05 10 13.5208 10.1958 13.9125 10.5875C14.3042 10.9792 14.5 11.45 14.5 12C14.5 12.55 14.3042 13.0208 13.9125 13.4125C13.5208 13.8042 13.05 14 12.5 14ZM12.5 8C11.95 8 11.4792 7.80417 11.0875 7.4125C10.6958 7.02083 10.5 6.55 10.5 6C10.5 5.45 10.6958 4.97917 11.0875 4.5875C11.4792 4.19583 11.95 4 12.5 4C13.05 4 13.5208 4.19583 13.9125 4.5875C14.3042 4.97917 14.5 5.45 14.5 6C14.5 6.55 14.3042 7.02083 13.9125 7.4125C13.5208 7.80417 13.05 8 12.5 8Z"
            fill="#27272A"
          />
        </g>
      </svg>
    </button>

    <transition
      enter-active-class="transition-all duration-150 ease-out"
      enter-from-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="transition-all duration-100 ease-in"
      leave-from-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
    >
      <div
        v-if="isOpen"
        class="absolute right-6 z-50 mt-2 w-40 rounded-lg border bg-white shadow-lg"
      >
        <ul class="flex flex-col text-sm text-gray-700">
          <li>
            <button
              @click.stop="$emit('edit', pipelineId)"
              class="block w-full cursor-pointer rounded px-3.5 py-2 text-left transition-colors duration-150 hover:bg-gray-100"
            >
              Edit
            </button>
          </li>
          <li>
            <button
              @click.stop="
                $emit('toggle-status', {
                  pipelineId: pipelineId,
                  status_value: !status
                })
              "
              class="block w-full cursor-pointer rounded px-3.5 py-2 text-left transition-colors duration-150 hover:bg-gray-100"
            >
              <FadeTransition>
                <span :key="status" class="block">
                  {{ status ? __('Inactivate') : __('Activate') }}
                </span>
              </FadeTransition>
            </button>
          </li>

          <!-- Separator -->
          <div v-if="isOwner">
            <li>
              <hr class="w-full border-t border-gray-200" />
            </li>

            <li>
              <button
                @click.stop="isDeleteModalOpen = true"
                class="block w-full cursor-pointer rounded px-3.5 py-2 text-left transition-colors duration-150 hover:bg-gray-100"
              >
                {{ __('Delete') }}
              </button>
            </li>
          </div>
        </ul>
      </div>
    </transition>
  </div>

  <PipelinesDeleteModal
    v-if="isDeleteModalOpen"
    :pipelineId="pipelineId"
    @delete="$emit('delete', $event)"
    @cancel="isDeleteModalOpen = false"
  >
  </PipelinesDeleteModal>
</template>

<script setup>
  import { ref } from 'vue';
  import FadeTransition from '../../../../components/global/FadeTransition.vue';
  import PipelinesDeleteModal from './PipelinesDeleteModal.vue';

  import { __ } from '@/helpers';
  const isDeleteModalOpen = ref(false);
  defineEmits(['toggle', 'toggleStatus', 'delete', 'edit']);

  const props = defineProps({
    status: {
      type: Boolean,
      required: false
    },
    pipelineId: {
      type: Number,
      required: false
    },
    isOwner: {
      type: Boolean,
      required: false
    },
    isOpen: {
      type: Boolean,
      required: false
    }
  });
</script>
